var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarBorder24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.405 3.56L10 3.87L7.275 6.235L8.09 9.75L5 7.885L1.91 9.75L2.73 6.235L0 3.87L3.595 3.565L5 0.25L6.405 3.56ZM3.11962 8.08506L4.99962 6.95006L6.88462 8.09006L6.38462 5.95006L8.04462 4.51006L5.85462 4.32006L4.99962 2.30006L4.14962 4.31506L1.95962 4.50506L3.61962 5.94506L3.11962 8.08506Z",
    fill: "#B6B6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBorder24Px);
export default __webpack_public_path__ + "static/media/star_border_24px.2f1a90a4a4d74a8d9603824813d71ed9.svg";
export { ForwardRef as ReactComponent };